import React, { Component } from "react";
import { connect } from "react-redux";
import { Cookies } from "react-cookie";
import { Link } from "react-router-dom"; 
import { LinkedIn } from 'react-linkedin-login-oauth2';
import $ from 'jquery';
import { getFbCode, getGoogleCode, getTwitterCode } from "../../utils/auth";
import { userSignUp, getIPDetails } from '../../actions/loginActions'
import { getInitialRoute, isAppleSafari, validateEmail, bootGuestIntercom, shutdownGuestIntercom } from "../../utils";
import queryString from 'query-string';
import moment from "moment";
import { addFacebookAccount, addGoogleReviewAccount, getFacebookDetails, googleUserDetails } from "./SocialAuth/connectSocialAcc";
import { HOST_URL, MediaBaseUrl } from "../../actions/api";
import { CAPTCHA_SITE_KEY } from "../../actions/constant";
import Recaptcha from 'react-google-invisible-recaptcha';
import { FontAwesomeIcon } from "../CommonComponents/AssetsHelper";
import GoogleOneTap from "./SocialAuth/GoogleOneTap";

const cookies = new Cookies();

const sitekey = CAPTCHA_SITE_KEY;

const containsSpecialChars = (str) => {
    const specialChars =
        /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    return specialChars.test(str);
}

const encourageEmail = (email) => {
    const conditions = ["@yahoo", "@gmail", "@hotmail"]
    return conditions.reduce((a, c) => a + email.includes(c), 0) == 1;
}

const abTest = moment().format("mm");
const channel = isAppleSafari() ? window : new BroadcastChannel('connect');

class SignUp extends Component {
    constructor(props) {
        super(props)
        this.captcha = React.createRef();
        this.onResolved = this.onResolved.bind( this );
    }

    state = {
        accountFullName: null,
        afNError: null,
        accountEmailId: cookies.get('emailAddress') ? cookies.get('emailAddress') : null,
        aEmailError: null, 
        aEmailMessageError: null,
        aEmailEncourager: null,
        accountPassword: null,
        reCaptcha: localStorage.getItem('_grecaptcha') ? localStorage.getItem('_grecaptcha') : true,
        loginLoader: false,
        utm_source: '',
        utm_campaign: '',
        firstInteractionPage: '', 
        loginError : 0,
        trackingPageUrl:''
    }

    onFullNameChange = event => this.setState({ accountFullName: event.target.value, afNError: containsSpecialChars(event.target.value) || String(event.target.value).length < 3 ? true : null })
    onEmailChange = event => this.setState({ accountEmailId: event.target.value, aEmailError: validateEmail(event.target.value) ? null : true, aEmailMessageError: null, aEmailEncourager: encourageEmail(event.target.value) })

    onClickToCreateAccount = async event => {
 
        const { afNError, aEmailError, accountFullName, accountEmailId, accountPassword, reCaptcha } = this.state;
        const { history } = this.props
        var activeProduct = "0";
        const route = getInitialRoute();
        if (route === 'widget') {
            activeProduct = "6"
        } else if (route === 'display' || route == "socialwalls") {
            activeProduct = "4"
        }
        if (validateEmail(accountEmailId) && !afNError && !aEmailError && accountFullName && String(accountFullName).length > 0 && accountEmailId && String(accountEmailId).length > 0 && accountPassword && String(accountPassword).length > 0  && reCaptcha) {
            let data = {};

            this.setState({ loginLoader: true })
            await getIPDetails().then((ipResponse) => {
                data = ipResponse.data;
            }).catch(ex => console.log(ex));

            const { utm_campaign, utm_source, firstInteractionPage, trackingPageUrl } = this.state;
            this.props.userSignUp({ socialWall:1, fullName: accountFullName, emailId: accountEmailId, password: accountPassword, activeProduct: activeProduct, createFrom: "signup", picture: "", oauth_uid: "", countryCode: (data && Object.keys(data).length > 0) ? data.country : "US", isBusinessAccount: Math.floor(abTest / 5) % 2 == 0 ? 1 : 0, utm_campaign: utm_campaign, utm_source: utm_source, referePageLink: firstInteractionPage, trackingPageUrl }, history, this.responseCallback, () => this.setState({ loginLoader: false }))

        }
         else {
            if (!accountFullName || String(accountFullName).length == 0) this.setState({ afNError: true })
            if (!accountEmailId || String(accountEmailId).length == 0 || !validateEmail(accountEmailId)) this.setState({ aEmailError: true })
            if (reCaptcha == null && accountFullName && accountEmailId && accountPassword) this.recaptcha.execute();
        }
    }

    onResolved = () => {
        const recaptcha = this.recaptcha.getResponse()
        this.setState({ reCaptcha : recaptcha },()=>{ localStorage.setItem('_grecaptcha',recaptcha);this.onClickToCreateAccount()})
      }


    validatePassword = event => {
        var password = event.target.value;
        $('#register-submit-btn').attr('disabled', true);
        $('#popover-password').show();
        var strength = 0;

        //If password contains both lower and uppercase characters, increase strength value.
        if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) {
            strength += 1;
            $('.low-upper-case').parent().addClass('active');
            $('#popover-password-top').addClass('hide');
        } else {
            $('.low-upper-case').parent().removeClass('active');
            $('#popover-password-top').removeClass('hide');
        }

        if (password.match(/([0-9])/)) {
            strength += 1;
            $('.one-number').parent().addClass('active');
            $('#popover-password-top').addClass('hide');
        } else {
            $('.one-number').parent().removeClass('active');
            $('#popover-password-top').removeClass('hide');
        }

        //If it has one special character, increase strength value.
        if (password.match(/([!,%,&,@,#,$,^,*,?,_,~])/)) {
            strength += 1;
            $('.one-special-char').parent().addClass('active');
            $('#popover-password-top').addClass('hide');
        } else {
            $('.one-special-char').parent().removeClass('active');
            $('#popover-password-top').removeClass('hide');
        }

        if (password.length > 7) {
            strength += 1;
            $('.eight-character').parent().addClass('active');
            $('#popover-password-top').addClass('hide');
        } else {
            $('.eight-character').parent().removeClass('active');
            $('#popover-password-top').removeClass('hide');
        }

        // If value is less than 2
        if (strength == 0) {
            $('#result').removeClass()
            $('#password-strength').addClass('progress-bar-danger');
            $('#result').addClass('text-danger').text('');
            $('#password-strength').css('width', '0%');
        } else if (strength == 1) {
            $('#result').removeClass()
            $('#password-strength').removeClass('progress-bar-warning');
            $('#password-strength').addClass('progress-bar-danger');
            $('#result').addClass('text-danger').text('Weak');
            $('#password-strength').css('width', '10%');
        } else if (strength == 2 || strength == 3) {
            $('#result').addClass('good');
            $('#password-strength').removeClass('progress-bar-danger');
            $('#password-strength').removeClass('progress-bar-success');
            $('#password-strength').addClass('progress-bar-warning');
            $('#result').addClass('text-warning').text('Average')
            $('#password-strength').css('width', '60%');
        } else if (strength == 4) {
            $('#register-submit-btn').attr('disabled', false);
            $('#result').removeClass()
            $('#result').addClass('strong');
            $('#password-strength').removeClass('progress-bar-warning');
            $('#password-strength').removeClass('progress-bar-danger');
            $('#password-strength').addClass('progress-bar-success');
            $('#result').addClass('text-success').text('Strong');
            $('#password-strength').css('width', '100%');
        }
        this.setState({ accountPassword: password })
    }
    showPass = event => {
        var x = document.getElementById("AccountPassword");

        var element = document.getElementById("show_password_icon");
        element.classList.toggle("view_pass");

        if (x.type === "password") {
            x.type = "text";
        } else {
            x.type = "password";
        }
    }
    responseCallback = (data) => {
        if (data && Object.keys(data).length > 0) this.setState({ aEmailError: true, loginError : data?.responseCode, aEmailMessageError: data.responseMessage, loginLoader: false });
    }


    onGSocialLogin = (provider, data) => {
        if (data && Object.keys(data).length > 0) {
            var picture = data.picture ? data.picture : "";
            const { utm_campaign, utm_source, firstInteractionPage, trackingPageUrl } = this.state;
            this.props.userSignUp({ socialWall: 1, fullName: data.name, emailId: data.email, password: "", activeProduct: `${getInitialRoute() === 'widget' ? '6' : getInitialRoute() === 'socialwalls' ? '4' : '0'}`, createFrom: provider, picture: picture, oauth_uid: data.sub, utm_campaign: utm_campaign, utm_source: utm_source, referePageLink: firstInteractionPage, trackingPageUrl }, this.props.history, this.responseCallback, () => this.setState({ loginLoader: false }))
        }
    }
    onSocialLogin = (provider, data ) => {
        if (data && Object.keys(data).length > 0) {
            var picture = `https://graph.facebook.com/${data.id}/picture`;
            const { utm_campaign, utm_source, firstInteractionPage, trackingPageUrl } = this.state;
            this.props.userSignUp({ socialWall: 1, fullName: data.name, emailId: data.email, password: "", activeProduct: `${getInitialRoute() === 'widget' ? '6' : getInitialRoute() === 'socialwalls' ? '4' : '0'}`, createFrom: provider, picture: picture, oauth_uid: data.id, utm_campaign: utm_campaign, utm_source: utm_source, referePageLink: firstInteractionPage, trackingPageUrl }, this.props.history, this.responseCallback, () => this.setState({ loginLoader: false }))
        }
    }
    onTwiSocialLogin = event => {
        localStorage.setItem("product", `${getInitialRoute() === 'widget' ? '6' : getInitialRoute() === 'socialwalls' ? '4' : '0'}`);
        getTwitterCode()
    }

    onLoginStart = () => {
        console.log('login start');
    }
    onLogoutSuccess = () => {
        console.log('logout success');
    }

    getGoogleAuthCode = () => {
        localStorage.setItem("connectionType", 'googleSignIn');
        getGoogleCode();
    }

    onOneTapSuccess = (provider, data) => {
        if (this.state.loginLoader) return;
        this.setState({ loginLoader: true }, () => this.onGSocialLogin(provider, data));
    }

    getFacebookAuthCode = () => {
        localStorage.setItem("connectionType", 'facebookSignIn');
        getFbCode(3);
    }

    getGoogleUserDetails = (token) => {
        googleUserDetails(token).then(res => this.onGSocialLogin("google", res.data));
    }

    getFacebookUserDetails = (token) => {
        getFacebookDetails({access_token: token}).then(res => this.onSocialLogin('facebook', res.data));
    }

    readAuthenticationCode = (event) => {
        const response = JSON.parse(event.data);
        const { utm_campaign, utm_source, firstInteractionPage, loginLoader, trackingPageUrl } = this.state;
        if (!loginLoader) {
            if (response && Object.keys(response).length > 0) {
                if (response.type == "googleSignIn") {
                    this.setState({ loginLoader: true }, () => addGoogleReviewAccount(response.data, (data) => this.getGoogleUserDetails(data.token)))
                } else if (response.type == "facebookSignIn") {
                    this.setState({ loginLoader: true }, () => addFacebookAccount(response.data, 3, (data) => this.getFacebookUserDetails(data.token)));
                } else {
                    if (response && response.fname && response.email && response.id) {
                        this.setState({ loginLoader: true }, () => this.props.userSignUp({ socialWall: 1, fullName: `${response.fname} ${response.lname}`, emailId: response.email, password: "", activeProduct: localStorage.getItem("product"), createFrom: "linkedin", picture: response.picture, oauth_uid: response.id, utm_campaign: utm_campaign, utm_source: utm_source, referePageLink: firstInteractionPage, trackingPageUrl }, this.props.history, this.responseCallback, () => this.setState({ loginLoader: false })));
                    }
                }
            }
        }
    }

    componentDidMount() {
        bootGuestIntercom();

        channel.addEventListener("message", this.readAuthenticationCode);

        const parsed = queryString.parse(window.location.search);

        if (parsed && Object.keys(parsed).length > 0) {
            const campaign = Array.isArray(parsed.utm_campaign) ? parsed.utm_campaign[parsed.utm_campaign.length - 1] : parsed.utm_campaign;
            const source = Array.isArray(parsed.utm_source) ? parsed.utm_source[parsed.utm_source.length - 1] : parsed.utm_source;

            this.setState({ utm_campaign: campaign, utm_source: source });
        } else {
            const utmParameter = cookies.get('__signupUtm');
            if (utmParameter && utmParameter.length > 0) {
                const decodedUtm = decodeURIComponent(utmParameter);
                const utms = decodedUtm.split('&');
                if (utms && utms.length > 0) {
                    utms.forEach(utm => {
                        const utmValue = utm.split('=');
                        const key = utmValue[0];
                        const value = utmValue[1];
                        this.setState(({ [key]: value }))
                    })
                }
            }
        }
        const initialPage = cookies.get('__initialPage') || parsed?.initialPage;
        const trackingPageUrl = cookies.get('tracking_URL') || '';
        
        if (initialPage && initialPage.length > 0) {
            this.setState({ firstInteractionPage: initialPage, trackingPageUrl });
        }

        const emailId = cookies.get('email');
        if (emailId && emailId.length > 0) {
            this.setState({ accountEmailId: emailId });
        }
    }

    componentWillUnmount() {
        shutdownGuestIntercom();
        channel.removeEventListener("message", this.readAuthenticationCode);
    }

    render() {
        const { prefix } = this.props
        const { reCaptcha, afNError, aEmailError, accountFullName, accountEmailId, aEmailMessageError, loginLoader, aEmailEncourager, loginError } = this.state
        return <>
            <GoogleOneTap onSuccess={this.onOneTapSuccess} disabled={loginLoader} context="signup" />

            <div className="loginFormSec registerFormSec formControlMin signup_wrapper">
                <div className="loginWithSocials">
                    <div className="loginHead">
                        <h2>Sign up for a free trial</h2> 
                        <p>All Premium Features <span className="seprate_dot"></span>No card required</p>
                    </div>
                    <div className="loginSocials">
                        <p className="text-center">Sign up with:</p>
                        <ul className="justify-content-center">
                            <li>
                                {/* <SocialGoogleLogin onUpdateData={this.onGSocialLogin} socialLogin={true}> */}
                                <button className="ladda-button  connect-google" id="googleplusSignIn" onClick={this.getGoogleAuthCode}>
                                    <img className="img-responsive me-2" src={`${MediaBaseUrl}icons/social-icons/google.svg`} width={"23"} height={"23"} />
                                    <span>Google</span>
                                </button>
                                {/* </SocialGoogleLogin> */}
                            </li>
                            <li>
                                <LinkedIn
                                    clientId="81k7ifnszqybqy"
                                    scope="r_emailaddress,r_liteprofile"
                                    redirectUri={`${HOST_URL}/accounts/linkedinGet`}
                                    onSuccess={(code) => {
                                        console.log(code);
                                    }}
                                    onError={(error) => {
                                        console.log(error);
                                    }}
                                >
                                    {({ linkedInLogin }) => (
                                        <button className="ladda-button  connect-linkedin" id="linkedinSignIn" onClick={() => { localStorage.setItem("product", `${getInitialRoute() === 'widget' ? '6' : getInitialRoute() === 'socialwalls' ? '4' : '0'}`); linkedInLogin() }}>
                                                <img className="img-responsive me-2" src={`${MediaBaseUrl}icons/social-icons/linkedin.svg`} width={"23"} height={"23"} />
                                            <span>LinkedIn</span>
                                        </button>
                                    )}
                                </LinkedIn>
                            </li>
                            <li>
                                <button className="ladda-button  connect-facebook" onClick={this.getFacebookAuthCode}>
                                    <img className="img-responsive me-2" src={`${MediaBaseUrl}icons/social-icons/facebook.svg`} width={"23"} height={"23"} />
                                    <span>Facebook</span>
                                </button>
                            </li>
                        </ul>
                        <h2><span>or</span></h2>
                    </div>
                </div>
                <div className="loginBlock">
                    <div className="loginInnSec">

                        <div>
                            <div className="row">
                                <div className="col-sm-12">

                                {aEmailError && loginError==1 ? <div id="flashFlushMessage" className="alert alert-block alert-danger fade show in flashNotification">
                                 <p className="mb-0">{aEmailMessageError}	</p>
                                </div> : null}

                                    <div className="form-group labelPosition">
                                        <label htmlFor="AccountFullName">Full Name</label>
                                        <input name="data[Account][fullName]" className={`form-control placeholder-no-fix ${afNError ? `form-error` : ``}`} type="text" id="AccountFullName" data-factors-input-id="form-0.field-0" value={accountFullName} onChange={this.onFullNameChange} />
                                        {afNError ? <div className="error-message">{accountFullName && accountFullName.length > 0 && containsSpecialChars(String(accountFullName)) ? `Special characters are not allowed. ` : String(accountFullName).length < 3 ? `Full Name length must be at least 3 characters long.` : ``} Enter Proper Name</div> : null}
                                    </div>
                                </div>

                                <div className="col-sm-12">
                                    <div className="form-group labelPosition">
                                        <label htmlFor="AccountEmailId">Company Email</label>
                                        <div className="email-input-wrapper">
                                            <input name="data[Account][emailId]" className={`form-control placeholder-no-fix email-input ${aEmailError && loginError != 1 ? `form-error` : ``}`} maxlength="255" type="email" id="AccountEmailId" data-factors-input-id="form-0.field-1" value={accountEmailId} onChange={this.onEmailChange} placeholder="name@work-email.com" required />
                                            <FontAwesomeIcon type={'regular'} icon={'envelope'} iconClass={'email-input-icon'} />
                                        </div>
                                        {aEmailEncourager ? <div id="flashFlushMessage" className="alert alert-block alert-custom bg-light fade show in flashNotification">
                                            <p className="mb-0 text-start">{Math.floor(abTest / 5) % 2 == 0 ? "Personalize your experience. Enter your work email instead." : "Swap personal emails for work emails for a better experience."}</p>
                                        </div> : null}
                                        {aEmailError && loginError!=1 ? <div className="error-message">{aEmailMessageError && aEmailMessageError.length > 0 ? aEmailMessageError : `Email is not valid.`}</div> : null}
                                    </div>

                                    <div className="form-group labelPosition">
                                        <label htmlFor="AccountPassword">Password</label>
                                        <div className="password-input-wrapper">
                                            <input name="data[Account][password]" className="form-control placeholder-no-fix password-input" minlength="8" maxlength="24" onChange={this.validatePassword} type="password" autoComplete={'off'} id="AccountPassword" placeholder="Enter your password" aria-autocomplete="list" />
                                            <FontAwesomeIcon type={'regular'} icon={'lock'} iconClass={'password-input-icon'} />
                                            <button id="show_password_icon" type="button" className="password-toggle-icon" onClick={this.showPass} data-factors-form-bind="true" data-factors-click-bind="true">
                                                <FontAwesomeIcon type={'regular'} icon={'eye'} iconClass={'eye-icon'} />
                                                <FontAwesomeIcon type={'regular'} icon={'eye-slash'} iconClass={'eye-slash-icon'} />
                                            </button>
                                        </div>
                                        <div id="popover-password" style={{ display: 'none' }}>
                                            <p style={{ textAlign: 'left' }}>Strength: <span id="result"></span></p>
                                            <div className="progress">
                                                <div id="password-strength" className="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style={{ width: '0%' }}>
                                                </div>
                                            </div>
                                            <ul className="list-unstyled verified_checkpoints">
                                                <li><span className="low-upper-case">
                                                    <i className="point_ver__"></i>
                                                </span>Upper Case & Lower Case Alphabets (A-z)</li>
                                                <li><span className="one-number">
                                                    <i className="point_ver__"></i>
                                                </span>1 Number (0-9)</li>
                                                <li><span className="one-special-char">
                                                    <i className="point_ver__"></i>
                                                </span>1 Special symbol (!@#$&*)</li>
                                                <li><span className="eight-character">
                                                    <i className="point_ver__"></i>
                                                </span>Minimum 8 Characters</li>
                                            </ul>
                                        </div>

                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div className="form-group recaptchaSec d-none">
                                        <Recaptcha
                                            ref={ ref => this.recaptcha = ref }
                                            sitekey={sitekey}
                                            onResolved={ this.onResolved } />
                                        {reCaptcha == false ? <div className="error-message">Please verify that you are not a robot.</div> : null}
                                    </div> 
                                    <div style={{ clear: 'both' }}></div>
                                    <div className="form-group">

                                        <button type="submit" className={`btn btn-primary w-100${loginLoader ? ' disabled' : ''}`} onClick={!loginLoader ? this.onClickToCreateAccount : null}>
                                            <span className="indicator-label" style={{ display: loginLoader ? 'none' : 'block' }}>Create Account</span>
                                            <span className="indicator-progress" style={{ display: !loginLoader ? 'none' : 'block' }}> Please wait...
                                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                            </span>
                                        </button>
                                    </div>


                                    <div className="form-group mb-0">
                                        <p>Already have an account? <Link className="btnSignUp" to={`${prefix}accounts/login`}>
                                            Login
                                        </Link></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="clear"></div>
            </div>
        </>
    }
}

const mapDispatchToProps = dispatch => {
    return {
        userSignUp: (data, history, responseCallback, stopLoader) => dispatch(userSignUp(data, history, responseCallback, stopLoader)),
    }
}
export default connect(null, mapDispatchToProps)(SignUp);